import { useLayoutEffect, type RefObject } from "react";

/**
 * Copies `message` into `setCustomValidity` so the field participates in
 * `:invalid` / `form.reportValidity()` and shows the **native** validation
 * tooltip (browser bubble), not only custom inline UI.
 */
export function useSyncConstraintValidationMessage(
  elementRef: RefObject<HTMLElement | null>,
  message: string | undefined,
): void {
  useLayoutEffect(() => {
    const el = elementRef.current;
    if (el == null || typeof (el as HTMLInputElement).setCustomValidity !== "function") {
      return;
    }
    const input = el as HTMLInputElement;
    const text = message != null && message !== "" ? message : "";
    input.setCustomValidity(text);
    return () => {
      input.setCustomValidity("");
    };
  }, [message]);
}
